import { render, staticRenderFns } from "./TopCurrencyText.vue?vue&type=template&id=347e1bf8&scoped=true&"
import script from "./TopCurrencyText.vue?vue&type=script&lang=js&"
export * from "./TopCurrencyText.vue?vue&type=script&lang=js&"
import style0 from "./TopCurrencyText.vue?vue&type=style&index=0&id=347e1bf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347e1bf8",
  null
  
)

export default component.exports